import { render, staticRenderFns } from "./AccessConfig.vue?vue&type=template&id=e80516ae"
import script from "./AccessConfig.vue?vue&type=script&lang=js"
export * from "./AccessConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports